import angular from 'angular';
import uiRouter from 'angular-ui-router';
import storeComponent from './store.component';
import Register from './register/register';
import StoreAdd from './storeAdd/storeAdd';

const storeModule = angular.module('tinaba.components.store', [
  uiRouter,
  Register.name,
  StoreAdd.name
])

.config(($stateProvider) => {
  'ngInject';

  $stateProvider
    .state('store', {
      url: '/store',
      template: '<store></store>',
      redirect: 'store.register'
    });
})

.component('store', storeComponent);

export default storeModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/store/store.js
 **/